/** $1 in the table's 8 value decimals: the "Hide low value balances" limit. */
export const LOW_VALUE_USD = 100_000_000n;
/** One unit of the table's sixth decimal, for 8-decimal amounts. */
const SHOWN_UNIT = 100n;
/** One cent in 8 value decimals. */
const CENT_USD = 1_000_000n;

/**
 * Whether a private balance gets a row. A remainder too small for the table's
 * six decimals reads as "0,000000" and is worth less than a cent (dust the
 * automatic return leaves behind): it is left out like a zero balance.
 */
export const showsPrivateBalance = (
  row: { amount: bigint; valueUsd: bigint },
  hideSmall: boolean
): boolean =>
  row.amount > 0n &&
  (row.amount >= SHOWN_UNIT || row.valueUsd >= CENT_USD) &&
  (!hideSmall || row.valueUsd > LOW_VALUE_USD);
